// formatters.js - Utility functions for text formatting
// Updated: 2026-01-21

/**
 * Formata o subtítulo: primeira letra maiúscula, remove underscores, corrige acentuação
 * @param {string} subStatus - O subtítulo a ser formatado
 * @returns {string} - O subtítulo formatado
 */
export const formatSubStatus = (subStatus) => {
  if (!subStatus) return '';
  
  // Mapeamento de correções de acentuação
  const acentuacoes = {
    'acao': 'Ação',
    'acoes': 'Ações',
    'conclusao': 'Conclusão',
    'analise': 'Análise',
    'situacao': 'Situação',
    'pendencia': 'Pendência',
    'pendencias': 'Pendências',
    'documentacao': 'Documentação',
    'regularizacao': 'Regularização',
    'negociacao': 'Negociação',
    'notificacao': 'Notificação',
    'protocolo': 'Protocolo',
    'protocolada': 'protocolada',
    'protocolado': 'protocolado',
    'finalizada': 'finalizada',
    'finalizado': 'finalizado',
    'aguardando': 'aguardando',
    'em': 'em',
    'de': 'de',
    'do': 'do',
    'da': 'da',
    'para': 'para',
    'com': 'com'
  };
  
  // Substitui underscores por espaços
  let formatted = subStatus.replace(/_/g, ' ').toLowerCase();
  
  // Divide em palavras e aplica correções
  const palavras = formatted.split(' ').map((palavra, index) => {
    // Verifica se existe correção para a palavra
    if (acentuacoes[palavra]) {
      // Se for a primeira palavra, capitaliza
      if (index === 0) {
        const corrigida = acentuacoes[palavra];
        return corrigida.charAt(0).toUpperCase() + corrigida.slice(1);
      }
      return acentuacoes[palavra];
    }
    // Se for a primeira palavra e não tem mapeamento, capitaliza
    if (index === 0) {
      return palavra.charAt(0).toUpperCase() + palavra.slice(1);
    }
    return palavra;
  });
  
  return palavras.join(' ');
};
